import React, { Component } from 'react'
import css from './infobulle.scss'

class Infobulle extends Component {
	render() {
		return (
			<div className={css.container}>
				<div className={css.main}>
					Réinitialiser&nbsp;le&nbsp;mot&nbsp;de&nbsp;passe
				</div>
				<div className={css.content}>{this.props.children}</div>
			</div>
		)
	}
}

export default Infobulle



// WEBPACK FOOTER //
// ./src/components/infobulle/infobulle.js